import React, { useContext } from 'react'
import { Button } from 'antd';
import { appContext } from '../../../AppContext';
import SkillsToChoseSl from './SkillToChoseSl';
import { useState } from 'react';


export default function SlAddSkill({
    newCharacter,
    allRaces,
    addSkillToCharacter
}) {
    const [appState] = useContext(appContext);
    const [isModalVisible, setIsModalVisible] = useState(false);
    
    if(!appState.isSlOfStory) {
        return null;
    }

    return (

        <>
            <Button onClick={() => setIsModalVisible(!isModalVisible)}>SL: Add skill</Button>
            <br />
            <br />

            <SkillsToChoseSl 
                setIsModalVisible={setIsModalVisible}
                isModalVisible={isModalVisible}
                allRaces={allRaces}
                newCharacter={newCharacter}
                addSkillToCharacter={addSkillToCharacter}
            />
        </>
    )
}